import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_OFFERS,
} from '../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import { OFFER_CARD_EDIT } from '../../../../constants/OfferConst';
import { PARTIAL_CHECKBOX_GREEN } from '../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const CmsOfferCardsTable = (props) => {
  const {
    offerList,
    page,
    rowsPerPage,
    handleCellMenuClick,
    selectedValue,
    handleClose,
    onClickRowViewDetails,
    onViewDetails,
    onClickDeleteOffer,
    handleChangePage,
    handleChangeRowsPerPage,
    onOpenDrawer,
    onActiveDeActiveOffer,
    permissions,
    setVisible,
    setOfferList,
    cmsOfferCards,
    selectedOfferCardListLength,
    isAllSelected,
    handleCheckboxChange,
    handleSelectAll,
  } = props;

  const validateEndDate = (offer) => {
    if (offer && offer.isActive) return true;
    if (offer && offer.schedule?.alwaysActive) return true;

    let endDate = moment();
    if (offer?.schedule?.scheduleType === 'RECURRING') {
      endDate = moment(
        `${offer?.schedule?.recurring?.endDate} ${offer?.schedule?.recurring?.recursTime}`,
        'DD-MM-YYYY HH:mm',
      );
    } else if (offer?.schedule?.scheduleType === 'ONE_TIME') {
      endDate = moment(
        `${offer?.schedule?.oneTime?.date} ${offer?.schedule?.oneTime?.time}`,
        'DD-MM-YYYY HH:mm',
      );
    }

    const toDay = moment(new Date(), 'DD-MM-YYYY');
    return !endDate?.isSameOrBefore(toDay);
  };

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className='w-10 ps-4'>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedOfferCardListLength}
                totalLength={cmsOfferCards?.length}
                inputProps={{
                  'aria-label': 'select all offers',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>
            <TableCell className='w-20'>Offer Card Name</TableCell>
            <TableCell className='w-20'>Offer Name</TableCell>
            <TableCell className='w-10'>Offer Card Type</TableCell>
            <TableCell className='w-20'>Offer Recipient</TableCell>
            <TableCell className='w-20' align='center'>
              Status
            </TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {(rowsPerPage > 0
            ? offerList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : offerList
          ).map((offerKey, key) => (
            <TableRow
              key={key}
              className='border-white pointer'
              onClick={(e) => {
                onClickRowViewDetails(offerKey, e);
              }}
            >
              {' '}
              <TableCell className='w-10 ps-4'>
                <Checkbox
                  onChange={() => handleCheckboxChange(offerKey?.id)}
                  checked={offerKey?.isChecked || false}
                  inputProps={{
                    'aria-label': `select offerKey ${offerKey.id}`,
                  }}
                />
              </TableCell>
              <TableCell>{offerKey?.offerCardName}</TableCell>
              <TableCell>{offerKey?.offerName}</TableCell>
              <TableCell>{offerKey?.type}</TableCell>
              <TableCell>{offerKey?.recipient}</TableCell>
              <TableCell onClick={(e) => onClickRowViewDetails(offerKey, e, true)}>
                <div className='d-flex justify-content-center'>
                  <div
                    className={`${offerKey.statusClass} pill d-flex justify-content-center align-items-center`}
                  >
                    <span className='ms-1'>{offerKey.status}</span>
                  </div>
                </div>
              </TableCell>
              <TableCell align='right'>
                {permissions[RBAC_TYPE_CMS_OFFERS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                  <Button
                    aria-controls='simple-menu'
                    aria-haspopup='true'
                    onClick={(e) => {
                      handleCellMenuClick(e, offerKey);
                    }}
                    className='showpopupInner'
                  >
                    <MoreHoriz className='showpopupInner' />
                  </Button>
                )}
                <Menu
                  id={key}
                  anchorEl={selectedValue?.anchorEl}
                  disableRestoreFocus
                  MenuListProps={{ autoFocusItem: false }}
                  keepMounted
                  open={Boolean(selectedValue.anchorEl) && selectedValue.id === offerKey.id}
                  onClose={handleClose}
                  className='shadow'
                >
                  {offerKey.status !== 'Completed' &&
                    (selectedValue?.offer?.isActive ? (
                      <MenuItem
                        className='pe-4'
                        onClick={(e) =>
                          onActiveDeActiveOffer(
                            e,
                            selectedValue?.offer?.isActive ? 'deactivate' : 'activate',
                          )
                        }
                      >
                        <RemoveCircle className='me-2 action-menu-icon' />
                        Deactivate
                      </MenuItem>
                    ) : (
                      validateEndDate(offerKey) && (
                        <MenuItem
                          className='pe-4'
                          onClick={(e) =>
                            onActiveDeActiveOffer(
                              e,
                              selectedValue?.offer?.isActive ? 'deactivate' : 'activate',
                            )
                          }
                        >
                          <AddCircle className='me-2 action-menu-icon' />
                          Activate
                        </MenuItem>
                      )
                    ))}

                  <MenuItem className='pe-4' onClick={(e) => onOpenDrawer(e, OFFER_CARD_EDIT)}>
                    <CreateIcon className='me-2 action-menu-icon' />
                    Edit
                  </MenuItem>
                  <MenuItem className='pe-4' onClick={(e) => onViewDetails(offerKey, e)}>
                    <VisibilityIcon className='me-2 action-menu-icon' />
                    View
                  </MenuItem>
                  <MenuItem className='pe-4' onClick={(e) => onClickDeleteOffer(e)}>
                    <DeleteForeverIcon className='me-2 action-menu-icon' />
                    Delete
                  </MenuItem>
                </Menu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>

        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={offerList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default CmsOfferCardsTable;
